export default __webpack_public_path__ + "static/state-of-epidemic-9dc431e65ce78de64bc0ee40a3636b18.svg";